export class FiltroBuscaSituacaoConsumidorReferenciaSorteio {

  consumidorId: number;
  sorteioId: number;

  constructor(consumidorId: number, sorteioId : number) {
      this.consumidorId = consumidorId;
      this.sorteioId = sorteioId;
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-busca-situacao-consumidor-referencia-sorteio.ts